import api from './api';

const cartService = {
  // Get cart (grouped by partner)
  getCart: async () => {
    try {
      const response = await api.get('/cart/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch cart'
      };
    }
  },

  // Add item to cart
  addToCart: async (data) => {
    try {
      const response = await api.post('/cart/add/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to add item to cart'
      };
    }
  },

  // Update cart item quantity
  updateCartItem: async (cartItemId, data) => {
    try {
      const response = await api.patch(`/cart/${cartItemId}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to update cart item'
      };
    }
  },

  // Remove item from cart
  removeCartItem: async (cartItemId) => {
    try {
      const response = await api.delete(`/cart/${cartItemId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to remove cart item'
      };
    }
  },

  // Clear entire cart
  clearCart: async () => {
    try {
      const response = await api.delete('/cart/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to clear cart'
      };
    }
  },

  // Checkout (single partner)
  checkout: async (data) => {
    try {
      const response = await api.post('/cart/checkout/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to checkout'
      };
    }
  },

  // Unified checkout (all partners at once)
  unifiedCheckout: async (data) => {
    try {
      const response = await api.post('/cart/unified-checkout/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to checkout'
      };
    }
  },

  // Validate coupon
  validateCoupon: async (couponCode, partnerId, subtotal) => {
    try {
      const response = await api.post('/coupons/validate/', {
        coupon_code: couponCode,
        partner_id: partnerId,
        subtotal: subtotal
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Invalid coupon'
      };
    }
  },

  // Apply coupon to specific cart item
  applyItemCoupon: async (cartItemId, couponCode) => {
    try {
      const response = await api.post(`/cart/${cartItemId}/coupon/`, {
        coupon_code: couponCode
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Failed to apply coupon'
      };
    }
  },

  // Remove coupon from specific cart item
  removeItemCoupon: async (cartItemId) => {
    try {
      const response = await api.delete(`/cart/${cartItemId}/coupon/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Failed to remove coupon'
      };
    }
  },
};

export default cartService;
